<template>
	<div class="row glosa" :id="id">
		<div class="col-9">
			<b-input-group size="sm"> 
				<template #prepend>
					<b-dropdown text="Ingrese o Seleccione Glosa" size="sm" required>
						<b-dropdown-item v-for="item in getLista" :key="item" @click="setGlosa(id, item)">{{ item }}</b-dropdown-item>
					</b-dropdown>
				</template>
				<b-form-input :id="'glosa_' + id" :name="'glosa_' + id" size="sm" class="glosa-glosa" :value="getGlosa" required></b-form-input>
			</b-input-group>
		</div>
		<div class="col-3">
			<b-input-group size="sm" prepend="Monto">
				<b-form-input :id="'monto_' + id" :name="'monto_' + id" 
					:value="getMonto" class="glosa-monto" type="number" size="sm" placeholder="Ingrese Monto" required></b-form-input>
			</b-input-group>
		</div>
	</div>
</template>
<script lang="ts">

	import { uuid } from "vue-uuid"
	import $ from "jquery"


	export default {
		name: "Glosa",
		props: {
			glosa: Object, // Si se creo una factura previamente y se esta editando, la informacion de las glosas viene en este objeto
		},
		data() {
			return {
				id: "", // ID unico del objeto en el DOM
				lista: [] // Objeto que guarda las Referencias predefinidas
			}
		},
		created() {

			// ID unico asociado a este objeto
			this.id = uuid.v1()

			// Creamos la lista de referencias predefinidas
			// Se deben mostrar los ultimos 12 periodos desde el mes en curso
			var now = new Date()
			var desde = new Date()
			desde.setFullYear(desde.getFullYear() - 1)
			desde.setMonth(desde.getMonth() + 1)

			while (desde <= now)
			{
				var anio = desde.getFullYear()
				var mes = desde.getMonth() + 1
				mes = mes < 10 ? "0" + mes : mes 
				this.lista.push("Servicio de transporte -- " + anio + "-" + mes)

				desde.setMonth(desde.getMonth() + 1)
			}
		},
		mounted: function() {

			// Informamos al componente "AgregarGlosa" el ID asignado a este objeto
			// Esto se hace para poder eliminar la fila desde el boton "-"
			this.$emit("evento-objeto-id", { tipo: 2, id: this.id })
		},
        computed: {

			// Devuelve la lista de referencias
            getLista() {

				return this.lista
			},

			// Devuelve la glosa
			getGlosa() {

				var value = ""
				if (this.glosa != undefined)
					value = this.glosa.comment

				return value
			},

			// Devuelte el monto
			getMonto() {

				var value = ""
				if (this.glosa != undefined)
					value = this.glosa.netUnitValue

				return value
			}
		},
		methods: {

			// Asigna el valor de la referencia seleccionada desde la lista, al INPUT que corresponde
			setGlosa(id, value) {

				$("#glosa_" + id).val(value)
			}
		}
	}
</script>
<style scoped>

	.glosa {
		margin-bottom: 5px;
	}
</style>
